module.exports = "../study/imgs/maps/Nagano/S8/Agriculture/Rice/Nagano_Rice_HadGEM2_RCP85_Mid.png";